import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastProvider } from "./hooks/useToast";
import Toasts from "./components/ui/Toasts";
import "./styles.css";
// Tiene que escuchar desde el primer instante: el navegador avisa de
// que se puede instalar la web una sola vez, al cargar (ver el archivo)
import "./utils/instalarApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Los avisos van por encima de TODO, también de la pantalla de
        acceso, así que el proveedor envuelve la aplicación entera */}
    <ToastProvider>
      <App />
      <Toasts />
    </ToastProvider>
  </React.StrictMode>
);

// Retirar la pantalla de bienvenida en cuanto la web está pintada
// (se desvanece; el nodo se elimina para no dejar nada en memoria)
const splash = document.getElementById("splash");
if (splash) {
  requestAnimationFrame(() => {
    splash.classList.add("hide");
    setTimeout(() => splash.remove(), 400);
  });
}
